import { todayIso, toIsoDate } from "./designCalendarModel";

const STORAGE_PREFIX = "crm.designCalendar.visto.";

function storageKey(userId) {
  return `${STORAGE_PREFIX}${userId || "anon"}`;
}

function avisoKey(kind, id) {
  return `${kind}:${Number(id)}`;
}

function addDays(iso, days) {
  const match = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  const date = new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3]) + Number(days || 0),
  );
  return toIsoDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

function readMap(userId) {
  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(userId, map) {
  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

export function markDesignCalendarVistoLocal(
  userId,
  kind,
  id,
  hoy = todayIso(),
) {
  const snoozeHasta = addDays(hoy, 1);
  if (!snoozeHasta) return null;
  const map = readMap(userId);
  map[avisoKey(kind, id)] = snoozeHasta;
  writeMap(userId, map);
  return snoozeHasta;
}

export function filterDesignCalendarAvisosLocal(
  items,
  userId,
  hoy = todayIso(),
) {
  const map = readMap(userId);
  return (items || []).filter((item) => {
    const until = map[avisoKey(item.kind, item.id)];
    if (!until) return true;
    return until <= hoy;
  });
}
